module.exports = "<section class=\"retailer has-footer-bar\">\r\n  <div class=\"tabs content-view\">\r\n    <div class=\"tab-wrapper\">\r\n      <tab-header header-text=\"{{'Retailer Reports' | translate}}\"\r\n                  is-active=\"true\"\r\n                  tabindex=\"-1\">\r\n      </tab-header>\r\n    </div>\r\n    <div class=\"tab-content\">\r\n      <retailer-reports-tab-content>\r\n      </retailer-reports-tab-content>\r\n    </div>\r\n  </div>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/retailer-reports/components/retailer-reports-page/retailer-reports-page.html
// module id = 1426
// module chunks = 0